import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** `cn(...)` is the shadcn-canonical class merge helper. Used throughout. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
